// Mock data for Gallop landing site

export const industries = [
  {
    id: 1,
    name: 'Restaurant & F&B',
    description: 'Kitchen operations, hygiene checklists, temperature logs',
    icon: 'Chef'
  },
  {
    id: 2,
    name: 'Retail',
    description: 'Store opening/closing, inventory checks, visual merchandising',
    icon: 'ShoppingBag'
  },
  {
    id: 3,
    name: 'Hospitality',
    description: 'Room inspections, guest services, maintenance workflows',
    icon: 'Hotel'
  },
  {
    id: 4,
    name: 'Facilities Management',
    description: 'Building maintenance, safety audits, asset management, service quality',
    icon: 'Sparkles'
  }
];

export const features = [
  {
    id: 1,
    title: 'Tasks & Workflows',
    description: 'Build repeatable task sequences directly from SOPs. Assign by role, shift, or location.',
    icon: 'ListChecks'
  },
  {
    id: 2,
    title: 'Audits & Checklists',
    description: 'Custom audits based on your standards. All results stored digitally with timestamps.',
    icon: 'ClipboardCheck'
  },
  {
    id: 3,
    title: 'Digital Logs',
    description: 'Paper-free logging for temperature, waste, maintenance. Cloud-stored and searchable.',
    icon: 'FileText'
  },
  {
    id: 4,
    title: 'Issue Tracking',
    description: 'Flag and resolve operational issues instantly. Track resolution time and responsibility.',
    icon: 'AlertCircle'
  },
  {
    id: 5,
    title: 'Dashboards & Reports',
    description: 'Real-time outlet scores and performance insights. Export compliance reports anytime.',
    icon: 'BarChart3'
  },
  {
    id: 6,
    title: 'Points & Gamification',
    description: 'Motivate teams through completion points and leaderboards. Celebrate top performers.',
    icon: 'Trophy'
  }
];

export const workflowSteps = [
  {
    id: 1,
    number: '01',
    title: 'Store Your SOPs',
    description: 'Keep every procedure and brand standard inside Gallop, version-controlled and searchable.',
    illustrationDesc: 'Manager uploading SOP documents tagged with safety, hygiene, and quality icons'
  },
  {
    id: 2,
    number: '02',
    title: 'Create Tasks & Workflows',
    description: 'Each SOP becomes a set of tasks grouped into workflows — your daily, weekly, and monthly routines.',
    illustrationDesc: 'Visual flow showing document transforming into checklist then workflow board'
  },
  {
    id: 3,
    number: '03',
    title: 'Run Audits & Track Compliance',
    description: 'Create custom audits based on tasks and standards, and store all results digitally.',
    illustrationDesc: 'Auditor reviewing digital checklist with data flowing into dashboard'
  },
  {
    id: 4,
    number: '04',
    title: 'Assign & Execute',
    description: 'Managers assign workflows and audits by outlet, role, or shift. Employees complete them and earn points for timely completion.',
    illustrationDesc: 'Supervisor assigning tasks to workers who check items and earn trophy icons'
  },
  {
    id: 5,
    number: '05',
    title: 'Monitor Outlet Health',
    description: 'All data rolls into a live dashboard scoring each outlet\'s operational health.',
    illustrationDesc: 'Map dashboard with color-coded outlets showing performance scores'
  }
];

export const testimonials = [
  {
    id: 1,
    quote: 'Gallop keeps our 30 outlets consistent and compliant.',
    author: 'COO',
    company: 'Serai Group'
  },
  {
    id: 2,
    quote: 'Our cleaning crews never miss a checklist now.',
    author: 'Operations Lead',
    company: 'Prasada Maju'
  }
];

export const partners = [
  { id: 1, name: 'Serai Group' },
  { id: 2, name: 'Ilham Inovasi' },
  { id: 3, name: 'Prasada Maju' }
];

export const industryOptions = [
  'Restaurant & F&B',
  'Retail',
  'Hospitality',
  'Facilities Management',
  'Healthcare',
  'Manufacturing',
  'Education',
  'Other'
];

export const outletOptions = [
  '1-5 outlets',
  '6-10 outlets',
  '11-20 outlets',
  '21-50 outlets',
  '50+ outlets'
];

export const contactTimeOptions = [
  'Morning (9am - 12pm)',
  'Afternoon (12pm - 3pm)',
  'Late Afternoon (3pm - 6pm)',
  'Flexible'
];